import React from "react";
import { IconButton } from "@src/components";

export const getExpertApprovalListColumns = (
    navigate: any,
    checkedItems: number[],
    setCheckedItems: (userExpertNo: number) => void,
) => {
    return [
        {
            Header: "선택",
            accessor: "expertNo",
            Cell: ({ cell: { value, row } }: any) => (
                <div style={{ width: "40px", textAlign: "center" }}>
                    {value && row.original.status !== "승인완료" && (
                        <input
                            type="checkbox"
                            checked={checkedItems.includes(value)}
                            style={{ width: "20px", height: "20px", cursor: "pointer" }}
                            onChange={() => setCheckedItems?.(value)}
                        />
                    )}
                </div>
            ),
        },
        {
            Header: "요청 상태",
            accessor: "status",
            Cell: ({ cell: { value } }: any) => (
                <div
                    style={{
                        width: "100px",
                        textAlign: "center",
                        backgroundColor: value !== "승인완료" ? "#8F50EA" : "#fff",
                        color: value !== "승인완료" ? "#fff" : "#8F50EA",
                        borderRadius: "50px",
                        padding: "4px 8px",
                    }}
                >
                    {value}
                </div>
            ),
        },
        {
            Header: "요청일시",
            accessor: "auctionAgentJoinRequestDate",
            Cell: ({ cell: { value } }: any) => <div style={{ width: "auto", textAlign: "center" }}>{value}</div>,
        },
        {
            Header: "이름",
            accessor: "name",
            Cell: ({ cell: { value } }: any) => <div style={{ width: "40px", textAlign: "center" }}>{value}</div>,
        },
        {
            Header: "수행기능",
            accessor: "categories",
            Cell: ({ cell: { value } }: any) => (
                <div style={{ width: "auto", textAlign: "center" }}>{Array.isArray(value) && value.join(", ")}</div>
            ),
        },

        {
            Header: "아이디(이메일)",
            accessor: "id",
            Cell: ({ cell: { value } }: any) => <div style={{ width: "120px", textAlign: "center" }}>{value}</div>,
        },
        {
            Header: "연락처",
            accessor: "phone",
            Cell: ({ cell: { value } }: any) => <div style={{ width: "120px", textAlign: "center" }}>{value}</div>,
        },

        {
            Header: "신청 내역 보러가기",
            accessor: "viewMore",
            Cell: ({ row }: any) => (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "40px",
                    }}
                >
                    <IconButton
                        type="arrow"
                        handleClick={() => {
                            navigate(`/experts/detail/${row?.original?.expertUserNo}`, { state: { from: "approval" } });
                        }}
                    />
                </div>
            ),
        },
    ];
};
